import { fetchApi } from "./base";

export interface FeedbackResponse {
  success: boolean;
  imageUrls?: string[];
}

export type FeedbackType = "feedback" | "bug";

export interface FeedbackData {
  email: string;
  title: string;
  message: string;
  images?: File[];
  type: FeedbackType;
}

export async function sendFeedbackEmail(
  data: FeedbackData,
): Promise<FeedbackResponse> {
  const formData = new FormData();

  formData.append("email", data.email);
  formData.append("title", data.title);
  formData.append("message", data.message);
  formData.append("type", data.type);

  if (data.images && data.images.length > 0) {
    data.images.forEach((file) => {
      formData.append("images", file);
    });
  }

  return await fetchApi<FeedbackResponse>("/api/feedback", {
    method: "POST",
    body: formData,
  });
}
